import { useMutation, useQueryClient } from "@tanstack/react-query";

import { toast } from "@/components/toast/toast-queue";
import { requestListKeys, trashKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

export function useRestoreRequests() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (requestId: number): Promise<void> => {
      apiClient.url(`/requests/restore/${requestId}`).post();
    },
    onError: (error: Error) => {
      toast.add({
        description: error.message || "Failed to restore requests",
        timeout: 3000,
        type: "error",
      });
    },
    onSuccess: () => {
      toast.add({
        description: "Request restored successfully",
        timeout: 3000,
        type: "success",
      });
      queryClient.invalidateQueries({ queryKey: trashKeys.all });
      queryClient.invalidateQueries({ queryKey: requestListKeys.all });
    },
  });
}
